import AdminCollect from "../../../admin/collects/one/index";
export default AdminCollect;